import React from 'react';
import moment from 'moment';

const ActividadCard = ({ 
    actividad, 
    onActividad, 
    onCompletarActividad, 
    esFechaVencida,
    truncarDescripcion 
}) => {
    const getEstadoClasses = () => {
        if (actividad.estado === 'completada') {
            return 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-600/20';
        }
        if (esFechaVencida(actividad.fecha_programada)) {
            return 'bg-rose-50 text-rose-700 ring-1 ring-rose-600/20';
        }
        return 'bg-amber-50 text-amber-700 ring-1 ring-amber-600/20';
    };

    const getEstadoText = () => {
        if (actividad.estado === 'completada') return 'Completada';
        if (esFechaVencida(actividad.fecha_programada)) return 'Vencida';
        return 'Pendiente';
    };

    return (
        <div 
            className="group p-4 hover:bg-slate-50 cursor-pointer transition-all duration-200 relative"
            onClick={() => onActividad(actividad)}
        >
            <div className="flex items-start gap-4">
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                        <h4 className="text-sm font-semibold text-slate-900 truncate">
                            {actividad.nombre}
                        </h4>
                        <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${getEstadoClasses()}`}>
                            {getEstadoText()}
                        </span>
                    </div>
                    
                    <p className="text-sm text-slate-600 line-clamp-2 mb-2">
                        {truncarDescripcion(actividad.descripcion)}
                    </p>

                    <div className="flex items-center gap-3 text-xs text-slate-500">
                        <div className="flex items-center gap-1">
                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                            {moment(actividad.fecha_programada).format('DD/MM/YYYY')}
                        </div>
                        
                        {actividad.estado !== 'completada' && (
                            <div 
                                className="ml-auto flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <label className="flex items-center gap-2 cursor-pointer hover:text-slate-700">
                                    <input
                                        type="checkbox"
                                        checked={actividad.estado === 'completada'}
                                        onChange={(e) => onCompletarActividad(actividad, e)}
                                        className="w-4 h-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500"
                                    /> 
                                    <span>Marcar como completada</span>
                                </label>
                            </div>
                        )}
                    </div>

                    {actividad.estado === 'completada' && actividad.observaciones && (
                        <div className="mt-3 p-3 bg-emerald-50 rounded-lg text-sm text-emerald-700">
                            <p className="font-medium mb-1">Observaciones:</p>
                            <p className="text-emerald-600">{actividad.observaciones}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ActividadCard; 